<template>
    <div>
        <TableList ref="tableList" v-bind="getData"></TableList>
    </div>
</template>

<script>
import { HttpGetTransplanList } from "@/service/transferplan";
import ajaxMixin from "../ajaxmixin";
import mixin from "../mixin";
import TableList from "@components/templates/tablelist";
import { mapState, mapGetters } from "vuex";
export default {
    props: ['bound'],
    components: {
        TableList,
    },
    mixins: [ajaxMixin, mixin],
    data() {
        return {};
    },
    created () {
        this.getMixinWarehouse(true);
    },
    computed: {
        ...mapGetters("dictionary", ["getCusproductList"]),
        getData() {
            return {
                ajaxRequest: HttpGetTransplanList,
                interceptRequest: (params) => {
                    return {
                        ...params,
                        search: {
                            ...params.search,
                            IN_status: this.bound == 1 ? [15, 20] : [25, 30],
                        },
                        isManage: true
                    }
                },
                startUp: true,
                Searchs: {
                    show: true,
                    style: "border:none;",
                    // labelWidth: 'auto',
                    align: "left",
                },
                SearchsData: [
                    {
                        label: "转运计划单号",
                        tag: "vInput",
                        key: "EQ_transitPlanOrderNo",
                        style: "width: 150px",
                        show: true,
                    },
                    {
                        label: "来源单号",
                        tag: "vInput",
                        key: "EQ_sourceNo",
                        style: "width:150px",
                        show: true,
                    },
                    {
                        label: "Shipment ID",
                        tag: "vInput",
                        key: "EQ_shipmentId",
                        style: "width: 150px",
                        show: true,
                    },
                    {
                        label: "Reference ID",
                        tag: "vInput",
                        key: "EQ_referenceId",
                        style: "width: 150px",
                        show: true,
                    },
                    // {
                    //     label: "项目",
                    //     tag: "Select",
                    //     options: this.getProductList,
                    //     key: "EQ_lineId",
                    //     style: "width: 160px",
                    //     show: true
                    // },
                ],
                columns: [
                    {
                        title: "转运计划单号",
                        key: "transitPlanOrderNo",
                    },
                    {
                        title: "来源单号",
                        key: "sourceNo",
                    },
                    {
                        title: "仓库",
                        key: "orgWarehouseId",
                        render: (h, { row }) => {
                            let warehouseItem = this.mixinWarehouseList.filter(
                                (item) => {
                                    return item.value == row.orgWarehouseId;
                                }
                            )[0];
                            return (
                                <div>
                                    {warehouseItem ? warehouseItem.label : "--"}
                                </div>
                            );
                        },
                    },
                    {
                        title: "项目",
                        key: "lineId",
                        render: (h, { row }) => {
                            let lineItem = this.getCusproductList.filter(
                                (item) => {
                                    return item.value == row.lineId;
                                }
                            )[0];
                            return (
                                <div>{lineItem ? lineItem.label : "--"}</div>
                            );
                        },
                    },
                    {
                        title: "Shipment ID",
                        key: "shipmentId"
                    },
                    {
                        title: "Reference ID",
                        key: "referenceId"
                    },
                    {
                        title: "单据状态",
                        render: (h, { row }) => {
                            let statusItem = this.getStatus.filter(item => {
                                return item.value == row.status;
                            })[0];
                            return <div>{statusItem ? statusItem.label : "--"}</div>
                        }
                    },
                    {
                        title: "操作",
                        align: "center",
                        width: 80,
                        render: (h, { row }) => {
                            return (
                                <div>
                                    <Button
                                        size="small"
                                        type="primary"
                                        onClick={this.handleSelect.bind(
                                            this,
                                            row
                                        )}
                                    >
                                        选择
                                    </Button>
                                </div>
                            );
                        },
                    },
                ],
            };
        },
    },
    methods: {
        handleSelect(item) {
            this.$emit("on-select", item);
            this.$emit("on-close");
        },
    },
};
</script>

<style>
</style>